import { blockInternal, requiresAuth, requiresTerms, blockLicenses } from "@/middleware";

const GroupView = () => import("./GroupView.vue");
const GroupSettingsView = () => import("./GroupSettingsView.vue");
const GroupResourcesView = () => import("./GroupResourcesView.vue");
const LicensesView = () => import("./LicensesView.vue");
const GroupSelectionView = () => import("./GroupSelectionView.vue");
const BulkInviteMembersView = () => import("./BulkInviteMembersView.vue");
const GroupSetUpTeachersView = () => import("./GroupSetUpTeachersView.vue");

const groupRoutes = [
  {
    path: "/groups",
    name: "GroupSelectionView",
    component: GroupSelectionView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms, blockInternal]
    }
  },
  {
    path: "/groups/:id",
    name: "Group",
    component: GroupView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms, blockInternal]
    }
  },
  {
    path: "/groups/:id/settings",
    name: "GroupSettings",
    component: GroupSettingsView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms, blockInternal]
    }
  },
  {
    path: "/groups/:id/resources",
    name: "GroupResources",
    component: GroupResourcesView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms, blockInternal]
    }
  },
  {
    path: "/groups/:id/licenses",
    name: "LicensesView",
    component: LicensesView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms, blockInternal, blockLicenses]
    }
  },
  {
    path: "/groups/:id/bulk-invite",
    name: "BulkInviteMembersView",
    component: BulkInviteMembersView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms, blockInternal]
    }
  },
  {
    path: "/groups/:id/set-up-teachers",
    name: "SetUpTeachers",
    component: GroupSetUpTeachersView,
    props: true,
    meta: {
      middleware: [requiresAuth, requiresTerms, blockInternal]
    }
  }
];

export default groupRoutes;
